import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import ContentSections from './components/ContentSections';
import FaqSection from './components/FaqSection';
import JsonLd from '@/components/base/JsonLd';
import { websiteSchema, organizationSchema } from '@/data/schema';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={[websiteSchema, organizationSchema]} />
      <Header />
      <main>
        <Hero />
        <CategorySection />
        <ContentSections />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}